import { BaseDto } from './base.dto';
import { EntityTypeFieldDto } from './entityTypeField.dto';
import { PrintConfigurationDto } from './printConfiguration.dto';

export enum PrintTriggerType{
    ON_CREATE,
    ON_UPDATE,
    ON_FIELD_VALUE_CHANGE,
    ON_DEMAND,
    VALIDATED_DEMAND
}
export class PrintConfigurationConditionDto extends BaseDto{
   
    type: PrintTriggerType;

    
    printConfiguration: PrintConfigurationDto;

    
    triggerField?: EntityTypeFieldDto;
    
    
    triggerFieldValues?: any[];
    triggerMeta?: any[];

    
    enabled: boolean;
}